<!-- Skeleton loader -->
@if (loading) {
  <div class="dash-main-content skeleton-container">
    <div class="dash-top">
      <h2 class="dash-title">Gestion des rôles</h2>
    </div>
    <div class="skeleton-header"></div>
    <div class="skeleton-search"></div>
    <div class="skeleton-tabs">
      <div class="skeleton-tab"></div>
      <div class="skeleton-tab"></div>
    </div>
    <div class="skeleton-table">
      @for (i of [1,2,3,4,5]; track i) {
        <div class="skeleton-row">
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
          <div class="skeleton-cell"></div>
        </div>
      }
    </div>
  </div>
}

@if (!loading) {
  <div class="dash-main-content">
    <div class="dash-top">
      <h2 class="dash-title">Gestion des rôles</h2>
    </div>
    <!-- Actions -->
    <div class="dash-top">
      <div class="dash-top-container">
        <div class="tags-group">
          <div class="badge success">{{ getTotalRoles() }} Rôle(s)</div>
          <div class="badge warning">{{ realmRoles.length }} Rôle(s) Realm</div>
          <div class="badge purple">{{ getTotalRoles() }} Rôle(s) Clients</div>
          <!-- <div class="badge info">{{ getCompositeRolesCount() }} Composites</div> -->
        </div>
        <div class="dash-action-right">
          <div class="field-search-btn">
            <input type="text" placeholder="Rechercher un rôle" class="search-icon" [formControl]="searchControl" />
            <button>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.0003 11.9998L4.00024 11.9998" stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                  <path d="M15.0003 17C15.0003 17 20.0002 13.3176 20.0002 12C20.0003 10.6824 15.0002 7 15.0002 7"
                    stroke="#1E1F24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
              </div>
              <button class="button button-icon primary" (click)="addRole()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4V20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M4 12H20" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span>Ajouter rôle</span>
              </button>
            </div>
          </div>
        </div>
        <!-- Tabs -->
        <div class="tabs">
          <div class="tab-list" role="tablist">
            <button role="tab" [attr.aria-selected]="selectedTabIndex === 0" [attr.aria-controls]="'panel-1'" id="tab-1"
              (click)="onTabChange(0)" [class.active]="selectedTabIndex === 0">
              Rôles Clients
            </button>
            <button role="tab" [attr.aria-selected]="selectedTabIndex === 1" [attr.aria-controls]="'panel-2'" id="tab-2"
              (click)="onTabChange(1)" [class.active]="selectedTabIndex === 1">
              Rôles Realm
            </button>
          </div>
          <div class="tab-panels">
            <!-- Panneau Realm -->
            <div id="panel-2" class="tab-panel" [style.display]="selectedTabIndex === 1 ? 'block' : 'none'" role="tabpanel"
              aria-labelledby="tab-2">
              <table class="table">
                <thead>
                  <tr>
                    <th>Rôle</th>
                    <th>Description</th>
                    <!-- <th>Composite</th> -->
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  @for (role of filteredRealmRoles; track role) {
                    <tr>
                      <td>{{ role.title || role.name }}</td>
                      <td>{{ role.description || '-' }}</td>
                      <!-- <td>
                      <div class="badge" [class.success]="role.composite">
                        {{ role.composite ? 'Oui' : 'Non' }}
                      </div>
                    </td> -->
                    <td>
                      <ul class="table-actions-icons">
                        <li>
                          <button class="button-no-style" (click)="editRole(role)">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path
                                d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
                                stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round" />
                                <path d="M13 4L20 11" stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round" />
                                <path d="M14 22L22 22" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round"
                                  stroke-linejoin="round" />
                                </svg>
                              </button>
                            </li>
                            <li>
                              <button class="button-no-style" (click)="viewRole(role)">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <circle cx="12" cy="12" r="10" stroke="#5C6465" stroke-width="1.5" />
                                  <path d="M11.992 15H12.001" stroke="#5C6465" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                    <path d="M12 12L12 8" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round"
                                      stroke-linejoin="round" />
                                    </svg>
                                  </button>
                                </li>
                                <li>
                                  <button class="table-actions-dropdown button-no-style" (click)="toggleDropdown($event, role)">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M11.992 12H12.001" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                        <path d="M11.9842 18H11.9932" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                                          stroke-linejoin="round" />
                                          <path d="M11.9998 6H12.0088" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                          </svg>
                                        </button>
                                        <ul class="table-actions-item" [class.hide]="!isDropdownOpen(role)">
                                          <li><a (click)="viewRole(role)">Voir détails</a></li>
                                          <li><a (click)="editRole(role)">Modifier</a></li>
                                          <li><button class="button-no-style text-gray fw-500 p-0"
                                          (click)="openDeleteDialog(role)">Supprimer</button></li>
                                        </ul>
                                      </li>
                                    </ul>
                                  </td>
                                </tr>
                              }
                              @if (filteredRealmRoles.length === 0) {
                                <tr>
                                  <td colspan="4" class="text-center">Aucun rôle realm trouvé</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                          @if (totalRealmRoles > 0) {
                            <div class="pagination-container">
                              <mat-paginator [length]="totalRealmRoles" [pageSize]="realmPageSize" [pageIndex]="realmCurrentPage"
                                [pageSizeOptions]="[10, 20, 50, 100]" (page)="onRealmPageChange($event)" showFirstLastButtons
                              class="modern-paginator"></mat-paginator>
                            </div>
                          }
                        </div>
                        <!-- Panneau Clients -->
                        <div id="panel-1" class="tab-panel" [style.display]="selectedTabIndex === 0 ? 'block' : 'none'" role="tabpanel"
                          aria-labelledby="tab-1">
                          <div class="accordion-wrapper">
                            @for (client of filteredClientsWithRoles; track client) {
                              <div class="accordion-item">
                                <button class="accordion accordion-elements" (click)="toggleClient(client)">
                                  <div class="accordion-left">
                                    <div class="flex gap-8 align-center">
                                      <div class="accordion-left-content">
                                        <div class="flex gap-8 align-center">
                                          <h6 class="m-0">{{ (client.name || client.clientId) | titlecase }}</h6>
                                          <!-- <span>|</span> -->
                                          <!-- <em>{{ client.clientId }}</em> -->
                                        </div>
                                        <!-- <span>{{ client.description || 'Aucune description' }}</span> -->
                                      </div>
                                    </div>
                                  </div>
                                  <div class="accordion-right flex gap-16 align-center">
                                    <div class="badge success">{{ client.roles.length }} Rôles</div>
                                    <span>|</span>
                                    <div class="flex gap-8 align-center">
                                      <span>{{ client.expanded ? 'Plier' : 'Déplier' }}</span>
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        @if (client.expanded) {
                                          <path d="M20 12L4 12" stroke="#141B34" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        }
                                        @if (!client.expanded) {
                                          <path d="M12 4V20M4 12H20" stroke="#1E1F24" stroke-width="1.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        }
                                      </svg>
                                    </div>
                                  </div>
                                </button>
                                <div class="panel panel-bordered" [style.display]="client.expanded ? 'block' : 'none'">
                                  <table class="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th>Rôle</th>
                                        <th>Description</th>
                                        <!-- <th>Composite</th> -->
                                        <th>Actions</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      @for (role of client.roles; track role) {
                                        <tr>
                                          <td>{{ role.title || role.name }}</td>
                                          <td>{{ role.description || '-' }}</td>
                                          <!-- <td>
                                          <div class="badge" [class.success]="role.composite">
                                            {{ role.composite ? 'Oui' : 'Non' }}
                                          </div>
                                        </td> -->
                                        <td>
                                          <ul class="table-actions-icons">
                                            <li>
                                              <button class="button-no-style" (click)="editRole(role)">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                  xmlns="http://www.w3.org/2000/svg">
                                                  <path
                                                    d="M14.0737 3.88545C14.8189 3.07808 15.1915 2.6744 15.5874 2.43893C16.5427 1.87076 17.7191 1.85309 18.6904 2.39232C19.0929 2.6158 19.4769 3.00812 20.245 3.79276C21.0131 4.5774 21.3972 4.96972 21.6159 5.38093C22.1438 6.37312 22.1265 7.57479 21.5703 8.5507C21.3398 8.95516 20.9446 9.33578 20.1543 10.097L10.7506 19.1543C9.25288 20.5969 8.504 21.3182 7.56806 21.6837C6.63212 22.0493 5.6032 22.0224 3.54536 21.9686L3.26538 21.9613C2.63891 21.9449 2.32567 21.9367 2.14359 21.73C1.9615 21.5234 1.98636 21.2043 2.03608 20.5662L2.06308 20.2197C2.20301 18.4235 2.27297 17.5255 2.62371 16.7182C2.97444 15.9109 3.57944 15.2555 4.78943 13.9445L14.0737 3.88545Z"
                                                    stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round" />
                                                    <path d="M13 4L20 11" stroke="#5C6465" stroke-width="1.5" stroke-linejoin="round" />
                                                    <path d="M14 22L22 22" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round"
                                                      stroke-linejoin="round" />
                                                    </svg>
                                                  </button>
                                                </li>
                                                <li>
                                                  <button class="button-no-style" (click)="viewRole(role)">
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                      xmlns="http://www.w3.org/2000/svg">
                                                      <circle cx="12" cy="12" r="10" stroke="#5C6465" stroke-width="1.5" />
                                                      <path d="M11.992 15H12.001" stroke="#5C6465" stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                        <path d="M12 12L12 8" stroke="#5C6465" stroke-width="1.5" stroke-linecap="round"
                                                          stroke-linejoin="round" />
                                                        </svg>
                                                      </button>
                                                    </li>
                                                    <li>
                                                      <button class="table-actions-dropdown button-no-style" (click)="toggleDropdown($event, role)">
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                                          xmlns="http://www.w3.org/2000/svg">
                                                          <path d="M11.992 12H12.001" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                            <path d="M11.9842 18H11.9932" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                                                              stroke-linejoin="round" />
                                                              <path d="M11.9998 6H12.0088" stroke="#23A93E" stroke-width="2.5" stroke-linecap="round"
                                                                stroke-linejoin="round" />
                                                              </svg>
                                                            </button>
                                                            <ul class="table-actions-item" [class.hide]="!isDropdownOpen(role)">
                                                              <li><a (click)="viewRole(role)">Voir détails</a></li>
                                                              <li><a (click)="editRole(role)">Modifier</a></li>
                                                              <li><button class="button-no-style text-gray fw-500 p-0"
                                                              (click)="openDeleteDialog(role)">Supprimer</button></li>
                                                            </ul>
                                                          </li>
                                                        </ul>
                                                      </td>
                                                    </tr>
                                                  }
                                                  @if (client.roles.length === 0) {
                                                    <tr>
                                                      <td colspan="4" class="text-center">Aucun rôle pour ce client</td>
                                                    </tr>
                                                  }
                                                </tbody>
                                              </table>
                                            </div>
                                          </div>
                                        }
                                        @if (filteredClientsWithRoles.length === 0) {
                                          <div class="text-center text-gray">
                                            Aucun client trouvé
                                          </div>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- End tabs -->
                              </div>
                            }